import { css, cx } from '@linaria/core';
import { ellipsis } from 'polished';
import { flex, theming } from 'styles/utils';
export const predictionSidebarGridCss = "omponents__CfUiItem__styles_ts-predictionSidebarGridCss-pszixlb";
export const actionable = "omponents__CfUiItem__styles_ts-actionable-a9vgqka";
export const conceptItemWrapper = cx(flex.init, flex.alignItems.center, "omponents__CfUiItem__styles_ts-conceptItemWrapper-cqba0w4");
export const textOutputItem = "omponents__CfUiItem__styles_ts-textOutputItem-tgfsu2g";
export const copyBtnWrapper = "omponents__CfUiItem__styles_ts-copyBtnWrapper-cw5efaa";
export const listItem = "omponents__CfUiItem__styles_ts-listItem-l6vztzl";
export const conceptName = "omponents__CfUiItem__styles_ts-conceptName-c1mjquff";
export const checkButton = "omponents__CfUiItem__styles_ts-checkButton-c7rand6";
export const groupedRegionItem = "omponents__CfUiItem__styles_ts-groupedRegionItem-gac0rb6";
export const dashedCount = "omponents__CfUiItem__styles_ts-dashedCount-dvo0f2t";
export const solidCount = "omponents__CfUiItem__styles_ts-solidCount-sml3gjn";
export const imageToText = "omponents__CfUiItem__styles_ts-imageToText-iwrwhum";
export const regionPills = "omponents__CfUiItem__styles_ts-regionPills-r1c5herq";
export const tagIcon = "omponents__CfUiItem__styles_ts-tagIcon-t1cuftgg";
export const innerContainer = "omponents__CfUiItem__styles_ts-innerContainer-i1k5imb9";
export const regionIcon = "omponents__CfUiItem__styles_ts-regionIcon-r1569niz";
export const regionItem = "omponents__CfUiItem__styles_ts-regionItem-rnhkim2";
export const negativeConceptLabel = "omponents__CfUiItem__styles_ts-negativeConceptLabel-nu5ohpq";
export const itemListContainer = "omponents__CfUiItem__styles_ts-itemListContainer-i1m6q8th";
export const itemListTitleContainer = "omponents__CfUiItem__styles_ts-itemListTitleContainer-i5jgov1";
export const itemListTitle = "omponents__CfUiItem__styles_ts-itemListTitle-i12ghrea";
export const titleDecoratorLine = "omponents__CfUiItem__styles_ts-titleDecoratorLine-t1stgmmi";
export const itemList = "omponents__CfUiItem__styles_ts-itemList-i1aij14d";

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");